<template>
	<div class="text-h4 text-weight-bold" id="pageTitle">{{ $t(title) }}</div>
	<div class="q-py-xs" id="pageDescription" v-if="description">{{ $t(description) }}</div>	
	<div class="mainContainer">
		<q-inner-loading :showing="!videoReady">
			<q-spinner size="50px" color="primary" />
		</q-inner-loading>
		<div class="videoContainer" v-show="!videoHidden">
			<video ref="video" :style="photoStyle" playsinline @canplay="initCanvas()">Stream Unavailable</video>
		</div>	
		<div class="imageContainer">
			<img id="imgPhoto" :src="portal.photoData" :style="photoStyle" v-if="showPhoto"/>
		</div>	
		<div class="buttonContainer">
			<q-btn color="primary" text-color="white" icon="camera_enhance" :label="$t('portal_takePhoto')" @click="takePicture()" v-if="videoReady && !showPhoto"/>
			<q-btn color="primary" text-color="white" :label="$t('portal_resetPhoto')" @click="resetPhoto()" v-if="showPhoto && validationCompleted"/>
		</div>
	</div>
	<div class="photo-validation-error" v-show="validationError">Validation Failed</div>
	<div class="validationContainer" v-show="!validationHidden">
		<div>
			<span class="result-icon">
				<q-icon v-if="validationCompleted && faceNotRotated" name="check_circle" color="green" size="1rem" />
				<q-icon v-if="validationCompleted && !faceNotRotated" name="cancel" color="red" size="1rem"/>
			</span>
			<span>{{$t('portal_faceNotRotated')}}</span>
			<span class="info-icon">
				<q-icon name="info" color="grey" size="1rem"/>
				<q-tooltip>{{$t('portal_faceNotRotatedTooltip')}}</q-tooltip>
			</span>
		</div>
		<div>
			<span class="result-icon">
				<q-icon v-if="validationCompleted && faceCloseToFrame" name="check_circle" color="green" size="1rem" />
				<q-icon v-if="validationCompleted && !faceCloseToFrame" name="cancel" color="red" size="1rem"/>
			</span>
			<span>{{$t('portal_faceCloseToFrame')}}</span>
			<span class="info-icon">
				<q-icon name="info" color="grey" size="1rem"/>
				<q-tooltip>{{$t('portal_faceCloseToFrameTooltip')}}</q-tooltip>
			</span>
		</div>
		<div>
			<span class="result-icon">
				<q-icon v-if="validationCompleted && faceCentreAligned" name="check_circle" color="green" size="1rem" />
				<q-icon v-if="validationCompleted && !faceCentreAligned" name="cancel" color="red" size="1rem"/>
			</span>
			<span>{{$t('portal_faceCenterAligned')}}</span>
			<span class="info-icon">
				<q-icon name="info" color="grey" size="1rem"/>
				<q-tooltip>{{$t('portal_faceCenterAlignedTooltip')}}</q-tooltip>
			</span>
		</div>
		<div>
			<span class="result-icon">
				<q-icon v-if="validationCompleted && whiteBackground" name="check_circle" color="green" size="1rem" />
				<q-icon v-if="validationCompleted && !whiteBackground" name="cancel" color="red" size="1rem"/>
			</span>
			<span>{{$t('portal_whiteBackground')}}</span>
			<span class="info-icon">
				<q-icon name="info" color="grey" size="1rem"/>
				<q-tooltip>{{$t('portal_whiteBackgroundTooltip')}}</q-tooltip>						
			</span>
		</div>
	</div>

	<canvas ref="canvas" style="display: none;"/>	
</template>

<style lang="less" scoped src="./photo-page.less"></style>
<script lang="ts" src="./photo-page.ts"></script>